import React from "react";
import b1 from "../../Images/b1.jpg";
import b2 from "../../Images/b2.jpg";
import b3 from "../../Images/b3.jpg";
import { Link } from "react-router-dom";
const Benefits = () => {
  return (
    <div className="mb-20 max-w-7xl mx-auto px-1">
      <h2 className="lg:text-5xl text-4xl text-center font-bold mt-10 pb-5 text-accent">
        Why choose us?
      </h2>
      <div
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10"
        style={{ fontFamily: "Roboto" }}
      >
        <div className="card card-side shadow w-5/6 mx-auto hover:scale-110 hover:duration-500 bg-white">
          <figure>
            <img className="h-100 w-20 bg-white" src={b3} alt="Shoes" />
          </figure>
          <div class="card-body bg-white">
            <h2 className="text-lg text-left font-bold text-accent">
              Free Home Delivery
            </h2>
            <p className="text-sm text-left text-gray-500">
              Dhaka provides free home delivery for all product. Outside Dhaka
              Tk 120
            </p>
          </div>
        </div>
        <div className="card card-side shadow w-5/6 mx-auto hover:scale-110 hover:duration-500 bg-white">
          <figure>
            <img className="h-100 w-20 bg-white" src={b2} alt="Shoes" />
          </figure>
          <div class="card-body bg-white">
            <h2 className="text-lg text-left font-bold text-accent">
              Quality Products
            </h2>
            <p className="text-sm text-left text-gray-500 hover:duration-500 bg-white">
              We ensure our product quality all times
            </p>
          </div>
        </div>
        <div className="card card-side shadow w-5/6 mx-auto hover:scale-110 hover:duration-500 bg-white">
          <figure>
            <img className="h-100 w-20 bg-white" src={b1} alt="Shoes" />
          </figure>

          <div class="card-body bg-white">
            <h2 className="text-lg text-left font-bold text-accent">
              <Link to="/cService">Online Support </Link>
            </h2>
            <p className="text-sm text-left text-gray-500">
              To satisfy our customer we try to give support online
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
